/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CloudIcon from '../../assets/UploadIcon';
import Theme from '../ui/Theme';
const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: 'none',
  },
  btnStyle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    display: 'flex',
    alignItems: 'center',
    color: Theme.palette.primary.main,
  },
}));

export default function UploadUnlockButton(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <input
        name={props.name}
        accept="image/png, image/jpeg, image/jpg"
        className={classes.input}
        id="unlock-button-file"
        multiple
        onChange={props.handleImageUpload}
        type="file"
      />
      <label htmlFor="unlock-button-file">
        <Button
          startIcon={<CloudIcon />}
          variant="contained"
          style={{ height: '24px', background: 'white' }}
          disableElevation
          component="span"
        >
          <div className={classes.btnStyle}>Upload</div>
        </Button>
      </label>
    </div>
  );
}
